function getTrackingParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    const trackingParams = {};

    const paramKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];

    paramKeys.forEach(key => {
        const value = urlParams.get(key);
        if (value) {
            trackingParams[key] = value;
        }
    });

    return trackingParams;
}

function storeTrackingParameters(trackingParams) {
    for (const [key, value] of Object.entries(trackingParams)) {
        localStorage.setItem(key, value);
    }
}

function main() {
    const trackingParams = getTrackingParameters();
    if (Object.keys(trackingParams).length > 0) {
        storeTrackingParameters(trackingParams);
        console.error('Tracking parameters stored in local storage:', trackingParams);
    } else {
        console.error('No tracking parameters found in the URL.');
    }
}

document.addEventListener('DOMContentLoaded', main);
